<div class="my-3 flex-justify-end">
  <svg class="icon-svg clickable-svg" (click)="prevPageClicked.emit()">
    <use xlink:href="#chevron-left"></use>
  </svg>
  <span class="mt-2">Viser {{ paginationStart }}-{{ paginationEnd }} af {{ total }}</span>
  <div>
    <bom-spinner *ngIf="isLoading" size="small"></bom-spinner>
  </div>
  <svg class="icon-svg clickable-svg" (click)="nextPageClicked.emit()">
    <use xlink:href="#chevron-right"></use>
  </svg>
</div>
